import { render, staticRenderFns } from "./TabProperties.vue?vue&type=template&id=5a0957f0&scoped=true&"
import script from "./TabProperties.vue?vue&type=script&lang=js&"
export * from "./TabProperties.vue?vue&type=script&lang=js&"
import style0 from "./TabProperties.vue?vue&type=style&index=0&id=5a0957f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0957f0",
  null
  
)

export default component.exports